import React from "react";
import { Section, FadeUp, SectionHeading, CtaButton } from "./primitives";
import { SCARCITY_MICRO } from "@/data/content";

export const Scarcity = () => (
  <Section className="bg-zinc-200">
    <div className="max-w-[720px] mx-auto text-center">
      <FadeUp>
        <SectionHeading>Extremely Limited Spaces</SectionHeading>
      </FadeUp>
      <FadeUp delay={0.05}>
        <div className="mt-8 space-y-6 text-lg md:text-xl text-zinc-700 leading-relaxed">
          <p>
            This is the first time I've run this as a cohort-based program, which means two things.
          </p>
          <p>
            First, to make sure everyone gets real, personal attention, I'm keeping the group small.
          </p>
          <p>
            Second, because you'll be helping shape it into something even better for the guitarists who come
            after you, it's priced lower than it will ever be again.
          </p>
        </div>
      </FadeUp>
      <FadeUp delay={0.1}>
        <div className="mt-12">
          <CtaButton testid="cta-scarcity-apply" microcopy={"Once the first cohort spaces are gone, they're gone."} />
        </div>
      </FadeUp>
    </div>
  </Section>
);
